import apiHandler from '../core/apiHandler';

const backupApi = apiHandler('backups');

export default backupApi;
